import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=4780d1e0&scoped=true&"
import script from "./Launcher.vue?vue&type=script&lang=js&"
export * from "./Launcher.vue?vue&type=script&lang=js&"
import style0 from "./Launcher.vue?vue&type=style&index=0&id=4780d1e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780d1e0",
  null
  
)

export default component.exports